import {useEffect, useState} from 'react';

export const getCurrentProjectName = () => {
    const projectName ='Lesia K';
    return projectName;
}
export const getCurrentPagePath = () => {
    const currentUrl = window.location.href;
    return new URL(currentUrl).pathname;
}

export const useReactPath = () => {
    const [path, setPath] = useState(getCurrentPagePath());
    const listenToPopstate = () => {
        console.log("Popstate event detected");
        const winPath = getCurrentPagePath();
        setPath(winPath);
    };
    useEffect(() => {
        console.log("Setting up popstate listener");
        window.addEventListener("popstate", listenToPopstate);
        return () => {
            console.log("Cleaning up popstate listener");
            window.removeEventListener("popstate", listenToPopstate);
        };
    }, []);
    return path;
};
